import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

export default class Input extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    infoMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    onKeyPress: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    disabled: PropTypes.bool,
    e2e: PropTypes.string,
    tabIndex: PropTypes.number,
  };

  static defaultProps = {
    value: '',
    maxLength: 0,
    disabled: false,
    errorMessage: null,
    tabIndex: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      charCount: props.value ? props.value.length : 0,
    };
  }

  onChange = (e) => {
    const value = e.target.value;

    const ret = this.props.onChange(String(value).trim(), this.props.name, e);

    if (this.props.name === 'mileage') {
      this.setState({ value: ret, charCount: value.length });
    } else {
      this.setState({ value, charCount: value.length });
    }
  };

  onKeyPress = (e) => {
    if (this.props.onKeyPress) {
      this.props.onKeyPress(e);
    }
  };

  onFocus = (e) => {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  };

  onBlur = (e) => {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  };

  render() {
    const {
      name,
      placeholder,
      label,
      maxLength,
      errorMessage,
      infoMessage,
      disabled,
      e2e,
      tabIndex,
      extStyle,
    } = this.props;
    const rootClassName = classNames(
      styles.input,
      {
        [styles['invalid']]: errorMessage,
        [styles['disabled']]: disabled,
      },
      extStyle
    );
    const countClassName = classNames(styles.charCount, {
      [styles['invalid']]: maxLength > 0 ? this.state.charCount > maxLength : false,
    });

    const showWrapper = errorMessage || infoMessage || maxLength > 0;

    return (
      <div className={rootClassName}>
        {label && (
          <div className={styles.label} aria-hidden="true">
            {label}
          </div>
        )}
        <input
          type="text"
          name={name}
          aria-label={label ? label.replace('*', ' Pflichtangabe') : undefined}
          placeholder={placeholder}
          value={this.state.value}
          autoComplete="off"
          maxLength={maxLength || 255}
          onChange={this.onChange}
          onKeyPress={this.onKeyPress}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          disabled={disabled}
          data-e2e={e2e}
          tabIndex={tabIndex}
          data-1p-ignore
        />

        {showWrapper && (
          <div className={styles.infoWrapper}>
            {infoMessage && !errorMessage && (
              <div className={styles.infoMessage} aria-live="assertive">
                {infoMessage}
              </div>
            )}
            {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
            {maxLength > 0 && (
              <div className={countClassName}>
                {this.state.charCount}/{maxLength}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
